'use client';

import { resolveDefaultMedianIncomeYear } from '@/app/(allowed)/median-income/constants';

import { Calculator } from './Calculator';
import { useMedianIncomeState } from './useMedianIncomeState';

interface MedianIncomePromoSidebarProps {
  /** false 면 아무것도 렌더하지 않음. 상위에서 본문에 "중위소득" 키워드가 있을 때만 true 로 켠다. */
  enabled: boolean;
}

/**
 * 상세 페이지 우측 사이드 promo 위젯 — `/median-income` 의 Calculator 를 그대로 재활용 +
 * "내 중위소득 확인하기 →" CTA 추가.
 * 모바일/태블릿에서는 숨김 — 그 폭은 `MedianIncomePromoMobile`(하단 sticky)이 맡는다.
 */
export const MedianIncomePromoSidebar = ({
  enabled,
}: MedianIncomePromoSidebarProps) => {
  const state = useMedianIncomeState(resolveDefaultMedianIncomeYear());

  if (!enabled) return null;

  return (
    <div className="sticky top-80 mobile-tablet:hidden">
      <Calculator state={state} showNavCta />
    </div>
  );
};
